import { Paper } from '@mui/material'
import ProfileAccount from '../../Profile/components/ProfileAccount'

export const Account = () => {
    return (
        <Paper
            variant="outlined"
            // temporary override for profile account
            sx={{
                overflow: 'auto',
                '> div': {
                    padding: '0 !important',
                },
                height: { xs: 'calc(100dvh - 330px)', sm: 'calc(100dvh - 290px)', md: 'unset' },
            }}
        >
            <ProfileAccount />
        </Paper>
    )
}
